import { Trans } from '@lingui/macro';
import { Button } from '@economic/taco';
import { useNavigate } from 'react-router-dom';
import manAndWomanGivingHighFiveSrc from '../../assets/man_and_woman_giving_high_five.svg';

export const SuccessStep = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="flex justify-center mb-6">
                <img src={manAndWomanGivingHighFiveSrc} alt="Man and woman giving high five" className="w-36" />
            </div>
            <h1 className="text-3xl text-center mb-4">
                <Trans>All done!</Trans>
            </h1>
            <p className="text-center text-sm mb-4">
                <Trans>Your data has been saved. Now you can navigate through the Payroll module.</Trans>
            </p>
            <p className="text-center text-sm font-bold mb-6">
                <Trans>We advise you to start from the company page and set your configurations.</Trans>
            </p>
            <div className="flex w-full justify-center">
                <Button
                    appearance="primary"
                    onClick={() => {
                        navigate('/payroll', { state: { onboarding: true } });
                    }}>
                    <Trans>Go to Løn</Trans>
                </Button>
            </div>
        </>
    );
};
